import type { EditableTokens, ResolvedAudienceSkinV1 } from '@/domain/release/types'

export type ValidationSkinName = 'wayfinding' | 'sport' | 'performance' | 'mist' | 'pitch' | 'champion' | 'homefire' | 'production'

export const validationSkinCatalog: ReadonlyArray<{ skinId: ValidationSkinName; name: string }> = [
  { skinId: 'wayfinding', name: '龙兴夜幕' },
  { skinId: 'sport', name: '晨光看台' },
  { skinId: 'performance', name: '星幕演出' },
  { skinId: 'mist', name: '山城晨雾' },
  { skinId: 'pitch', name: '绿茵脉冲' },
  { skinId: 'champion', name: '冠军金夜' },
  { skinId: 'homefire', name: '主场赤焰' },
  { skinId: 'production', name: '正式蓝渐' },
]

export const validationSkinTokens: Record<ValidationSkinName, EditableTokens> = {
  wayfinding: {
    'brand.primary': '#1D63D5', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#38D6FF', 'brand.onSecondary': '#071B35',
    'surface.page': '#071B35', 'surface.card': '#081F3B', 'surface.elevated': '#0C3158', 'surface.scrim': 'rgba(2,8,20,0.75)',
    'text.primary': '#F4F9FF', 'text.secondary': '#C4D5E8', 'text.inverse': '#F4F9FF', 'border.subtle': '#27577E', 'border.strong': '#4E91C2',
    'focus.ring': '#38D6FF', 'hero.overlayStart': 'rgba(6,18,38,0.02)', 'hero.overlayEnd': 'rgba(2,8,20,0.68)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  sport: {
    'brand.primary': '#B42318', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#9A3412', 'brand.onSecondary': '#FFFFFF',
    'surface.page': '#FFF6F3', 'surface.card': '#FFFFFF', 'surface.elevated': '#FFF9F6', 'surface.scrim': 'rgba(43,23,19,0.60)',
    'text.primary': '#2B1713', 'text.secondary': '#75524B', 'text.inverse': '#FFFFFF', 'border.subtle': '#E9CEC7', 'border.strong': '#C99B90',
    'focus.ring': '#7A271A', 'hero.overlayStart': 'rgba(43,23,19,0.04)', 'hero.overlayEnd': 'rgba(43,23,19,0.74)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  performance: {
    'brand.primary': '#7858F4', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#F0B35A', 'brand.onSecondary': '#24142F',
    'surface.page': '#140F26', 'surface.card': '#21183A', 'surface.elevated': '#2D2150', 'surface.scrim': 'rgba(10,6,20,0.75)',
    'text.primary': '#FBF8FF', 'text.secondary': '#C9BCE4', 'text.inverse': '#FFFFFF', 'border.subtle': '#514173', 'border.strong': '#8069AB',
    'focus.ring': '#D5C6FF', 'hero.overlayStart': 'rgba(20,15,38,0.04)', 'hero.overlayEnd': 'rgba(10,6,20,0.76)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  mist: {
    'brand.primary': '#176B87', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#357F98', 'brand.onSecondary': '#FFFFFF',
    'surface.page': '#E7F0F3', 'surface.card': '#F8FCFD', 'surface.elevated': '#DDEBED', 'surface.scrim': 'rgba(21,50,60,0.58)',
    'text.primary': '#15323C', 'text.secondary': '#526E77', 'text.inverse': '#FFFFFF', 'border.subtle': '#C1D5DA', 'border.strong': '#86AEB8',
    'focus.ring': '#176B87', 'hero.overlayStart': 'rgba(231,240,243,0.02)', 'hero.overlayEnd': 'rgba(21,50,60,0.66)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  pitch: {
    'brand.primary': '#1B8561', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#58D6A7', 'brand.onSecondary': '#061A18',
    'surface.page': '#061A18', 'surface.card': '#0B2A25', 'surface.elevated': '#123A32', 'surface.scrim': 'rgba(2,14,12,0.75)',
    'text.primary': '#F1FFF8', 'text.secondary': '#A9D2C1', 'text.inverse': '#FFFFFF', 'border.subtle': '#28594C', 'border.strong': '#4B8C77',
    'focus.ring': '#58D6A7', 'hero.overlayStart': 'rgba(6,26,24,0.02)', 'hero.overlayEnd': 'rgba(2,14,12,0.76)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  champion: {
    'brand.primary': '#C28A2C', 'brand.onPrimary': '#11182A', 'brand.secondary': '#F1C56E', 'brand.onSecondary': '#11182A',
    'surface.page': '#11182A', 'surface.card': '#1A2439', 'surface.elevated': '#26334D', 'surface.scrim': 'rgba(7,11,22,0.75)',
    'text.primary': '#FFF9EA', 'text.secondary': '#D4C7A9', 'text.inverse': '#FFFFFF', 'border.subtle': '#4D5870', 'border.strong': '#81745B',
    'focus.ring': '#F1C56E', 'hero.overlayStart': 'rgba(17,24,42,0.02)', 'hero.overlayEnd': 'rgba(7,11,22,0.78)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  homefire: {
    'brand.primary': '#C7463B', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#FF9D72', 'brand.onSecondary': '#241012',
    'surface.page': '#241012', 'surface.card': '#37181B', 'surface.elevated': '#4A2022', 'surface.scrim': 'rgba(20,6,7,0.75)',
    'text.primary': '#FFF6F2', 'text.secondary': '#E0B9AE', 'text.inverse': '#FFFFFF', 'border.subtle': '#714044', 'border.strong': '#A66363',
    'focus.ring': '#FF9D72', 'hero.overlayStart': 'rgba(36,16,18,0.02)', 'hero.overlayEnd': 'rgba(20,6,7,0.78)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
  production: {
    'brand.primary': '#2D70EE', 'brand.onPrimary': '#FFFFFF', 'brand.secondary': '#55C8FF', 'brand.onSecondary': '#041B36',
    'surface.page': '#061C36', 'surface.card': '#0A2B50', 'surface.elevated': '#123E6C', 'surface.scrim': 'rgba(2,10,24,0.75)',
    'text.primary': '#F4F9FF', 'text.secondary': '#ABC4DF', 'text.inverse': '#FFFFFF', 'border.subtle': '#285A84', 'border.strong': '#4B86B6',
    'focus.ring': '#55C8FF', 'hero.overlayStart': 'rgba(6,28,54,0.02)', 'hero.overlayEnd': 'rgba(2,10,24,0.72)', 'shape.radiusPreset': 'balanced', 'elevation.preset': 'layered',
  },
}

const lockedTokens: ResolvedAudienceSkinV1['lockedTokens'] = {
  'status.urgent': '#C62828', 'status.warning': '#9A5700', 'status.success': '#147A4B', 'route.entry': '#2F80FF', 'route.exit': '#7A4DC2',
  'annotation.medical': '#C62828', 'annotation.accessible': '#38D6FF', 'annotation.service': '#2F80FF', 'boundary.strong': '#5B6F86',
  'qr.foreground': '#000000', 'qr.background': '#FFFFFF',
}

const fixtureChecksums: Record<ValidationSkinName, string> = {
  wayfinding: '5423546bb5ad1ec0556f17f0e963e13d79afd826c328911df66797c740e9118c',
  sport: '6cdd75e8f7e3319e01a05492f59a1b2ce8b88c7fcb0baa3d0361bbb6c79e5067',
  performance: 'a47e34b80ee5805d1388d3ad71fa481ad0eda76623f487358e309f182b04836d',
  mist: '21a08df18b79c4f4f8218dc6c92e26695ddb89d835d00faa88d483ee48ea6796',
  pitch: '62b4a64d6b04b7800e49e746b976648b84e009e014022181c71d33574e5de23a',
  champion: 'c743ecd0777ae0a06853e57ed96229d98b0c3c92b7a089ce40789f21a102ad52',
  homefire: '71c2f42c6d033d6416a9175aa2818e622c4980d8bfbf7f06917f7e677f9b839e',
  production: 'cf04c54683af1f7f996df61a5837ac1814ed0be25bc7773ed61f41976c2c6743',
}

export function createValidationSkin(name: ValidationSkinName): ResolvedAudienceSkinV1 {
  return {
    schemaVersion: 'venue-audience-skin/v1', resolvedSkinId: `fixture-${name}`, themeResolverVersion: 'vf-theme-resolver/v1',
    sourceVersions: [{ scope: 'SYSTEM', versionId: `fixture-${name}-v1` }], tokens: validationSkinTokens[name], lockedTokens,
    assets: { logo: null, hero: null, pageBackground: null }, checksum: fixtureChecksums[name],
  }
}

export function createLegacyCompatibilitySkin(): ResolvedAudienceSkinV1 {
  // Legacy content may still be adapted during migration, but its retired CSS
  // skin is never restored. All content renders through the V2 wayfinding skin.
  return createValidationSkin('wayfinding')
}
